import React from 'react';
import { MapPin, Clock, Phone } from 'lucide-react';
import { Card } from '../components/ui/card';
import { storeLocations } from '../data/mock';

const RetailPresence = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-32 bg-black text-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              Retail Presence
            </h1>
            <p className="text-2xl md:text-3xl text-gray-300 leading-relaxed">
              Visit us at 6 strategic locations across Ulaanbaatar
            </p>
          </div>
        </div>
      </section>

      {/* TONYMOLY Locations */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              TONYMOLY Stores
            </h2>
            <p className="text-xl text-gray-600">
              Experience Korean beauty innovation at our 8 TONYMOLY locations across Ulaanbaatar
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {storeLocations.tonymoly.map((store) => (
              <Card 
                key={store.id}
                className="p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white border-gray-200"
              >
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-6 h-6 text-black flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-1">
                        {store.name}
                      </h3>
                      <p className="text-gray-600">{store.floor}</p>
                      <p className="text-gray-500 text-sm mt-1">{store.address}</p>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-gray-200 space-y-2">
                    <div className="flex items-center space-x-3 text-sm text-gray-600">
                      <Clock className="w-4 h-4" />
                      <span>{store.hours}</span>
                    </div>
                    {store.phone && (
                      <div className="flex items-center space-x-3 text-sm text-gray-600">
                        <Phone className="w-4 h-4" />
                        <span>{store.phone}</span>
                      </div>
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Portmeirion Locations */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Portmeirion Stores
            </h2>
            <p className="text-xl text-gray-600">
              Discover British elegance and timeless design at our Portmeirion boutiques
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {storeLocations.portmeirion.map((store) => (
              <Card 
                key={store.id}
                className="p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white border-gray-200"
              >
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-6 h-6 text-black flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-1">
                        {store.name}
                      </h3>
                      <p className="text-gray-600">{store.floor}</p>
                      <p className="text-gray-500 text-sm mt-1">{store.address}</p>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-gray-200 space-y-2">
                    <div className="flex items-center space-x-3 text-sm text-gray-600">
                      <Clock className="w-4 h-4" />
                      <span>{store.hours}</span>
                    </div>
                    <div className="flex items-center space-x-3 text-sm text-gray-600">
                      <Phone className="w-4 h-4" />
                      <span>{store.phone}</span>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Ecover Showroom */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Ecover Showroom
            </h2>
            <p className="text-xl text-gray-600">
              Visit our Ecover showroom for clean air solutions and sustainable living products
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            {storeLocations.ecover.map((store) => (
              <Card 
                key={store.id}
                className="p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white border-gray-200"
              >
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-6 h-6 text-black flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-1">
                        {store.name}
                      </h3>
                      <p className="text-gray-600">{store.floor}</p>
                      <p className="text-gray-500 text-sm mt-1">{store.address}</p>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-gray-200 space-y-2">
                    <div className="flex items-center space-x-3 text-sm text-gray-600">
                      <Clock className="w-4 h-4" />
                      <span>{store.hours}</span>
                    </div>
                    <div className="flex items-center space-x-3 text-sm text-gray-600">
                      <Phone className="w-4 h-4" />
                      <span>{store.phone}</span>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-6">
              For more information about Ecover products and air purification solutions
            </p>
            <a 
              href="http://www.ecovermongolia.mn/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <button className="bg-black text-white hover:bg-gray-800 rounded-full px-8 py-4 text-lg font-semibold transition-all duration-300 hover:scale-105">
                Visit Ecover Mongolia Website
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* Map Section Placeholder */}
      <section className="py-24 bg-gray-900 text-white">
        <div className="container mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Find Us in Ulaanbaatar
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            All our stores are conveniently located in major shopping centers across the city
          </p>
          <div className="bg-gray-800 rounded-2xl p-16 text-gray-400">
            <MapPin className="w-16 h-16 mx-auto mb-4 opacity-50" />
            <p className="text-lg">Interactive map coming soon</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RetailPresence;
